import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Text, SimpleFlexbox } from 'ctm-components';
import { resultsConfigSelector } from 'ctm-selectors';

/**
 * SidebarToggle Component
 * @return {Node} SidebarToggle Component
 */
class _SidebarToggle extends PureComponent {

    /**
     * Should Show Toggle check
     * @returns {Node} Buttons
     */
    showToggle = () => {
        const { isSM, isDisplayingResults, isCompareModeActive } = this.props;
        return isSM && isDisplayingResults && !isCompareModeActive;
    };

    /**
     * Build out a stacked Button with label
     * @param {String} label button label
     * @param {String} icon button icon
     * @param {String} sideBarAccordionValue accordion value for sidebar
     * @param {Boolean} visibility visibility of button
     * @returns {Node} Buttons
     */
    getButton = (label, icon, sideBarAccordionValue, visibility = true) => {
        const actions = [
            {
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'isDisplayingSidebar',
                value: true
            },
            {
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'selectedSidebarAccordion',
                value: sideBarAccordionValue
            }
        ];
        return visibility ? (
            <SimpleFlexbox display="flex" column itemsCenter="xs" margin="right">
                <Button icon={icon} size="large" UIComponent="btn_primary_transparent_small_rounded" variant="icon_only" onClickActions={actions} />
                <Text label={label} size="small" color="brand_primary" />
            </SimpleFlexbox>
        ) : null;
    };

    render = () => {
        const { isAvailableResults } = this.props;
        return this.showToggle() ? (
            <SimpleFlexbox display="flex" contentEnd="sm">
                {this.getButton('Refine', 'ctm_filter', 'Refine results', isAvailableResults)}
                {this.getButton('Edit details', 'ctm_pencil', 'Edit my details')}
            </SimpleFlexbox>
        ) : null;
    };

}

_SidebarToggle.propTypes = {
    isSM: PropTypes.bool,
    isAvailableResults: PropTypes.bool,
    isDisplayingResults: PropTypes.bool,
    isCompareModeActive: PropTypes.bool
};

/**
 * Maps the store state to component props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    const resultsConfig = resultsConfigSelector(state);
    return {
        isSM: state.get('browser').mediaType === 'sm',
        isAvailableResults: resultsConfig.get('isAvailableResults'),
        isDisplayingResults: resultsConfig.get('isDisplayingResults'),
        isCompareModeActive: resultsConfig.get('compareModeActive')
    };
};

const SidebarToggle = connect(mapStateToProps)(_SidebarToggle);

export { _SidebarToggle, SidebarToggle };
